import { gql, TypedDocumentNode } from '@apollo/client'

import { GOOGLE_AD_MANAGER_CONNECTION_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_GOOGLE_AD_MANAGER_CONNECTION: TypedDocumentNode<Data, Variables> = gql`
  ${GOOGLE_AD_MANAGER_CONNECTION_FRAGMENT}

  query getGoogleAdManagerConnection($workspaceId: ID!) {
    node(id: $workspaceId) {
      ... on Workspace {
        latestGamConnectionOrder {
          ...GoogleAdManagerConnectionFragment
        }
      }
    }
  }
`
